import React, { useEffect, useState } from 'react'
import { styled } from '@mui/system'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';

function Viewcategory(){
    const apiUrl = API_URL;
    const [items, setItems] = useState([]);
    const viewId = useParams();
    const categoryId = viewId.categoryid;
    const [addkey, setaddkey] = useState('');

    useEffect(() => {
        const getComments = async () => {
          try{
            const postData = {
                category_id: categoryId
            };
            const res = await fetch(`${apiUrl}/admin/viewcategory`,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            });
            const data = await res.json();
            if(data.status !== 200){
              throw new Error('Data not found');
            }
            setItems(data.data);
            setaddkey(data.data.keywords)
          }catch(error){
            console.error('Error ', error)
          }
        };
        getComments();
      }, []);
      let industryname = '';
      let subcatname = '';
      if(items.industryname === ""){
        industryname = 'No Industry found.';
      }
      else{
        industryname = items.industryname;
      }
      if(items.subcategoryname === ""){
        subcatname = 'No subcategory found.';
      }
      else{
        subcatname = items.subcategoryname;
      }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>View Category</h2>
            <div className='commonCntr'>
              <form className="form-horizontal" action="">
                  <div className="form-group">
                      <label className="control-label col-sm-2 label">Category Name:</label>
                      <div className="col-sm-10 mt-1">
                          <span>{items.categoryname}</span>
                      </div>
                  </div>
                  <div className="form-group mt-4">
                      <label className="control-label col-sm-2 label">Industry Name:</label>
                      <div className="col-sm-10 mt-1">
                          <span>{industryname}</span>
                      </div>
                  </div>
                  <div className="form-group mt-4">
                      <label className="control-label col-sm-2 label">Subcategory Name:</label>
                      <div className="col-sm-10 mt-1">
                          <span>{subcatname}</span>
                      </div>
                  </div>
                  <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="categorykeywords">Add Keywords:</label>
                        <div className="col-sm-4">
                          <span className='d-block mt-2'>{addkey}</span>
                        </div>
                  </div>
              </form>
            </div>
        </div>
    )
}

export default Viewcategory; 